"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.langToShortLang = exports.getNavigatorLang = exports.getCookieLang = exports.setCookieLang = exports.convertPandaI18nFormatToLocalResource = exports.inLang = exports.getRandomKey = exports.getLangValue = exports.formatLocale = exports.debugError = exports.debuginfo = exports.error = exports.warn = void 0;
var forEach_1 = __importDefault(require("lodash/forEach"));
var mapValues_1 = __importDefault(require("lodash/mapValues"));
var languageList_1 = __importDefault(require("../config/languageList"));
var lang_1 = require("../const/lang");
var cookie_1 = require("./cookie");
var const_1 = require("../const");
var warn = function (msg) {
    if (typeof console !== 'undefined' &&
        window.__PANDA.logLevel >= 2) {
        console.warn("[panda-log] Warn: ".concat(msg));
    }
};
exports.warn = warn;
var error = function (msg) {
    if (typeof console !== 'undefined' &&
        window.__PANDA.logLevel >= 1) {
        console.error("[panda-log] Error: ".concat(msg));
    }
};
exports.error = error;
var debuginfo = function (msg) {
    if (typeof console !== 'undefined' && window.__PANDA.debug) {
        console.error("[panda-log] Debug: ".concat(msg));
    }
};
exports.debuginfo = debuginfo;
var debugError = function (msg) {
    if (typeof console !== 'undefined' && window.__PANDA.debug) {
        console.error("[panda-log] Error:", msg);
    }
};
exports.debugError = debugError;
/**
* 语种格式转换：en-US ， en_US,  en_us , en，全部格式化为en-US
* @param {string} locale 语种
*/
var formatLocale = function (locale) {
    var str = locale;
    try {
        var result_1 = locale.toLowerCase();
        result_1 = locale.replace('_', '-');
        var temp = result_1.split('-');
        if (temp && temp.length) {
            if (temp.length > 1) {
                temp[1] = temp[1].toUpperCase();
                str = temp.join('-');
            }
            else {
                languageList_1.default.forEach(function (item) {
                    if (item.lang === result_1) {
                        str = item.locale;
                    }
                });
            }
        }
    }
    catch (err) {
        if (typeof err === 'string') {
            (0, exports.error)(err);
        }
        else {
            console.error(err);
        }
    }
    return str;
};
exports.formatLocale = formatLocale;
/**
* 获取cookie中语种的值
* @param {string} defaultLang 默认语种
// * @param {string} cookieKey cookie的key
*/
var getLangValue = function (options) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (options === void 0) { options = {}; }
    // 取出来的值可能并不是语种，需要格式化
    var lang = options.lang;
    var cookieKey = ((_a = window.__PANDA) === null || _a === void 0 ? void 0 : _a.cookieKey) || const_1.DEFAULT_COOKIE_KEY;
    // 获取CDN给予的cookieKey, 如果没有默认走x-hrg
    var customLang = cookieKey !== const_1.DEFAULT_COOKIE_KEY && (0, cookie_1.getCookie)(cookieKey) ? getCookieLang(cookieKey) : '';
    var xhngLang = cookieKey === const_1.DEFAULT_COOKIE_KEY && (0, cookie_1.getCookie)(const_1.DEFAULT_COOKIE_KEY) ? getCookieLang(const_1.DEFAULT_COOKIE_KEY) : '';
    var windowLang = (_b = window.__PANDA) === null || _b === void 0 ? void 0 : _b.lang;
    var searchLang = (_c = window.__PANDA) === null || _c === void 0 ? void 0 : _c.searchLang;
    var localLang = (_d = window.__PANDA) === null || _d === void 0 ? void 0 : _d.localLang;
    var matchXhng = (_e = document === null || document === void 0 ? void 0 : document.cookie) === null || _e === void 0 ? void 0 : _e.match(/x-hng/g);
    var isMultiXhng = matchXhng && Array.isArray(matchXhng) && matchXhng.length > 1;
    var osLang = (_g = (_f = window._GATEWAY_PF) === null || _f === void 0 ? void 0 : _f.userPreference) === null || _g === void 0 ? void 0 : _g.lang;
    // 当x-hng冲突时（存在多个的情况） 提升localLang的权重
    (0, exports.debuginfo)("isMultiXhng: ".concat(isMultiXhng ? 'true' : 'false', "; lang: ").concat(lang, " || searchLang: ").concat(searchLang, " || osLang: ").concat(osLang, " || customLang: ").concat(customLang, " || localLang: ").concat(localLang, " || xhngLang: ").concat(xhngLang, " || windowLang: ").concat(windowLang));
    var usedLang = isMultiXhng
        ? lang || searchLang || osLang || customLang || localLang || xhngLang || windowLang || const_1.DEFAULT_LANG
        : lang || searchLang || osLang || customLang || xhngLang || localLang || windowLang || const_1.DEFAULT_LANG;
    usedLang = (0, exports.formatLocale)(usedLang);
    // 如果全局设置的langList（允许语种），则最终会受限制
    if (window.__PANDA.langList && window.__PANDA.langList.length) {
        if (!window.__PANDA.langList.includes(usedLang)) {
            usedLang = window.__PANDA.langList[0];
        }
    }
    return usedLang;
};
exports.getLangValue = getLangValue;
function getRandomKey() {
    return Math.random()
        .toString(36)
        .slice(2);
}
exports.getRandomKey = getRandomKey;
function inLang(lang) {
    return !!lang_1.langList.find(function (item) { return item.value === lang; });
}
exports.inLang = inLang;
function convertPandaI18nFormatToLocalResource(pandaString) {
    var pandaFormat = {};
    (0, forEach_1.default)(pandaString, function (v, k) {
        pandaFormat[(0, exports.formatLocale)(k)] = (0, mapValues_1.default)(v.copyList, function (item) { return item.content; });
    });
    return pandaFormat;
}
exports.convertPandaI18nFormatToLocalResource = convertPandaI18nFormatToLocalResource;
/** 如果非x-hng则设置值，x-hng只处理lang部分 */
function setCookieLang(lang) {
    if (window.__PANDA.cookieKey === const_1.DEFAULT_COOKIE_KEY) {
        var xhngValue = (0, cookie_1.getCookie)(const_1.DEFAULT_COOKIE_KEY);
        if (!xhngValue) {
            (0, cookie_1.setCookie)(const_1.DEFAULT_COOKIE_KEY, "lang=".concat(lang));
        }
        else {
            var newUrlP_1 = new URLSearchParams();
            (new URLSearchParams(xhngValue)).forEach(function (v, k) {
                if (k === 'lang') {
                    newUrlP_1.set(k, lang);
                }
                else {
                    newUrlP_1.set(k, v);
                }
            });
            (0, cookie_1.setCookie)(const_1.DEFAULT_COOKIE_KEY, newUrlP_1.toString());
        }
    }
    else {
        (0, cookie_1.setCookie)(window.__PANDA.cookieKey, lang);
    }
}
exports.setCookieLang = setCookieLang;
/** 如果非x-hng则返回值，x-hng则返回lang部分的值 */
function getCookieLang(key) {
    if (key === const_1.DEFAULT_COOKIE_KEY) {
        return (new URLSearchParams((0, cookie_1.getCookie)(const_1.DEFAULT_COOKIE_KEY))).get('lang') || const_1.DEFAULT_LANG;
    }
    return (0, cookie_1.getCookie)(key) || const_1.DEFAULT_LANG;
}
exports.getCookieLang = getCookieLang;
function getNavigatorLang() {
    if (typeof navigator !== 'undefined') {
        if (navigator.language) {
            if (inLang(navigator.language)) {
                return navigator.language;
            }
            if (inLang((0, exports.formatLocale)(navigator.language))) {
                return (0, exports.formatLocale)(navigator.language);
            }
        }
        return navigator.languages.find(function (_lang) { return inLang(_lang); }) || const_1.DEFAULT_LANG;
    }
    return const_1.DEFAULT_LANG;
}
exports.getNavigatorLang = getNavigatorLang;
function langToShortLang(lang) {
    return lang.startsWith('zh-') ? lang.toLocaleLowerCase() : lang.split('-')[0];
}
exports.langToShortLang = langToShortLang;
